import React from "react";
import PropTypes from "prop-types";
import { Tag } from "@td/ui";
import { translate } from "@td/shared_utils";

const COLORS = {
  URGENT: "#BF4600",
};

const Priority = React.memo(({ value, ...props }) => (
  <Tag
    {...props}
    color={COLORS[value]}
    label={translate(null, "care_team_tasks.priorities", value)}
  />
));

Priority.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Priority;
